import { Employee } from '../../ea-huddle-v2/interfaces/interface';
import { OrgChartEmployee } from '../types/orgChart.types';

export function convertEmployeeToOrgChartEmployee(employee: Employee): OrgChartEmployee {
  const nameParts = (employee.employee_name || '').split(' ');
  const firstName = nameParts[0] || '';
  const lastName = nameParts.slice(1).join(' ') || '';

  return {
    login: employee.login_name?.toLowerCase() || '',
    firstName,
    lastName,
    email: employee.employee_internal_email_address || '',
    jobTitle: employee.job_title_name || '',
    jobLevel: employee.job_level_name || '',
    city: employee.location_city_name || '',
    country: employee.location_state_name || '',
    department: employee.department_name_current || '',
    directReports: [],
    isManuallyAdded: true
  };
}

export function convertOrgChartEmployeeToEmployee(orgEmployee: OrgChartEmployee): Employee {
  return {
    login_name: orgEmployee.login,
    employee_name: `${orgEmployee.firstName} ${orgEmployee.lastName}`.trim(),
    employee_internal_email_address: orgEmployee.email,
    job_title_name: orgEmployee.jobTitle,
    job_level_name: orgEmployee.jobLevel,
    location_city_name: orgEmployee.city,
    location_state_name: orgEmployee.country,
    department_name_current: orgEmployee.department
  };
}

export function convertLoginsToEmails(logins: Set<string>, employees: Map<string, OrgChartEmployee>): Set<string> {
  const emails = new Set<string>();
  logins.forEach((login) => {
    const employee = employees.get(login);
    if (employee?.email) {
      emails.add(employee.email.toLowerCase());
    }
  });
  return emails;
}
